/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from "react"
import ProviderTable from "./Table"
import Limit from "../../../components/Limit"
import Pagination from "../../../components/Pagination"
import SearchEmptyScreen from "../../../components/SearchEmptyScreen"
import Emptyscreen from "../../../components/EmptyScreen"
import CustomOverLay from "../../../components/CustomOverLay"
import { useGetProviderAssociatedToPatientListQuery } from "../../../features/patientSlice"
import { useLocation, useSearchParams } from "react-router-dom"
import GlobalContext from "../../../components/Context/GloablContext"
import { useGetProviderAlertQuery } from "../../../features/dashBoardSlice"
import HelpGuideModal from "../../../components/HelpGuideModal"
import { useGetHelpGuideAdminQuery } from '../../../features/patientSlice'

export default function ProviderAlertList({ patientId, setIsStateLoading }) {

    const { isSideBar } = useContext(GlobalContext)
    const location = useLocation()
    const [limit, setLimit] = useState("15")
    const [searchParams, setSearchParams] = useSearchParams('')
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const [suggestions, setSuggestions] = useState("")
    const [isSortselected, setisSortSelected] = useState(false)

    const getFilteredSearchParams = () => {
        const filteredParams = new URLSearchParams(searchParams);
        filteredParams.delete("tabname"); // Remove 'tabname'
        return filteredParams.toString(); // Return the updated searchParams as a string
    };
    const filteredSearchParams = getFilteredSearchParams();
    // const { data: providerData, isFetching: providerlistfetch, isLoading: providerloading, status: providerstatus, refetch: refetchProvider } = useGetProviderAlertQuery(`${patientId}&${searchParams}`, { skip: searchParams?.size < 2, refetchOnMountOrArgChange: true });

    const { data: providerData, isFetching: providerlistfetch, isLoading: providerloading, status: providerstatus, refetch: refetchProvider } = 
    useGetProviderAlertQuery(`${patientId}&${filteredSearchParams}`, { 
        skip: filteredSearchParams.length < 2, 
        refetchOnMountOrArgChange: true 
    });

    // Check if other search parameters exist and append them to the query string
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params[key] = value

        setSearchParams({ ...params })
    }

    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
    }
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType = localStorage?.getItem('user_type') !== null ? localStorage.getItem('user_type') : sessionStorage.getItem('user_type')

    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });



    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-dashboard-provider-alerts');
        } else {
            setQueryParamsadmin('type=corporate-dashboard-provider-alerts');
        }
    }, [userType]);

    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);


    useEffect(() => {

        if (location.state !== null && location.state !== '' && location?.state?.limit !== undefined && !Array.isArray(location.state)) {
            let params = {
                'limit': location.state.limit,
                'page_number': location.state.page_number,
            };
            setSearchParams({ ...params });
        } else {
            if (!searchParams?.get('limit')) {
                handleSearchParams('limit', '15');
            }
            if (!searchParams?.get('page_number')) {
                handleSearchParams('page_number', '1');
            }
        }
    }, [location, searchParams]);

    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params })
    }

    useEffect(() => {
        if (providerstatus !== 'fulfilled') {
            setIsStateLoading(true)
        } else {
            setIsStateLoading(false)
        }
    }, [providerstatus]);

    return (
        <div className='bg-white rounded-lg py-3 h-[calc(100vh-391px)] relative'>
            {((providerlistfetch && providerstatus !== "fulfilled" && providerstatus !== "rejected" && !isSortselected) || (providerloading) || (providerData === undefined && providerstatus !== "fulfilled" && providerstatus !== "rejected")) ? <CustomOverLay Active text="Loading Provider Alert list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'linked_providers_overlay' : 'opened_linked_providers_overlay'}`} /> : (providerData !== undefined && providerData?.data?.length > 0) ?
                <>
                    <div className="flex justify-end mb-[14px] items-center">
                        {
                            userType !== 'super-admin' &&
                            <span onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span>
                        }

                    </div>


                    <div>
                        <ProviderTable
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            List={providerData}
                            handleSearchParams={handleSearchParams}
                            sortValue={searchParams.get('sort') || ''}
                            setisSortSelected={setisSortSelected}
                            patientId={patientId}
                        />
                    </div>
                    {providerData?.total_count >= 15 &&
                        <div className="-mx-8">
                            <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                                <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(providerData?.total_count))}</p>
                                <div className="flex items-center">
                                    <Limit
                                        limit={limit}
                                        setLimit={setLimit}
                                        handleNoOfRowsClick={handleNoOfRowsClick}
                                        isColumnSelect={isColumnSelect}
                                    />
                                    <Pagination
                                        TotalCount={parseInt(providerData?.total_count)}
                                        totalPageNumber={Math.ceil(parseInt(providerData?.total_count) / parseInt(searchParams?.get("limit")))}
                                        handleOnClickPageNumber={handleOnClickPageNumber}
                                        limit={parseInt(limit)}
                                    />
                                </div>
                            </div>
                        </div>}
                </> : <>
                    {(providerData?.total_count === 0 && suggestions?.trim() !== "") || (providerData?.success_status === "false") || (searchParams.get('start_date') !== null || searchParams.get('end_date') !== null || searchParams.get('organization_name') !== null) ?
                        <SearchEmptyScreen text={"No exact matches found. Please try a different search"} isPatient={true} />
                        :
                        providerData?.total_count === 0 && !searchParams.get("search") ? <Emptyscreen
                            title={"Provider List"}
                            provider={true}
                            PatientNotes={true}
                            FirstPTag={"No Providers alerts yet ."}
                        /> : ((providerstatus === "rejected" || (providerData?.total_count !== 0 && providerData?.data?.length === 0)) && <SearchEmptyScreen alertTableheight={true} text={"No data found"} />)
                    }
                </>}
            {(helpGuideModel && helpguidestatus === "fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
            }
        </div>
    )
}